// extracted by mini-css-extract-plugin
export default {"LazyImage":"LazyImage_LazyImage__63MY-"};